import AuditInfo from 'components/audit/AuditInfo';
import ActionHeader from 'components/forms/ActionHeader';
import ContentMenu, { ContentMenuRow } from 'components/forms/ContentMenu';
import GridItemList, { Row } from 'components/GridItemList';
import PaddedLayout from 'layout/MainLayout/PaddedLayout';
import { MinDto } from 'types/other';
import { t } from 'utils/getTranslations';
import { getIdLink } from 'utils/linkUtil';

export type EntityViewSection = {
    titleId: string;
    rows: Row[];
};

type Props = {
    data: EntityViewSection[];
    titleId: string;
    titleSuffixComponent?: React.ReactNode;
    actions: React.ReactNode;
    onBack?: () => void;
    createdAt?: string | Date;
    createdByEmployee?: MinDto;
    lastModifiedAt?: string | Date;
    changedByEmployee?: MinDto;
};

export default function EntityView({
    data,
    titleId,
    actions,
    onBack,
    titleSuffixComponent,
    createdAt,
    createdByEmployee,
    lastModifiedAt,
    changedByEmployee,
}: Props) {
    const getContentMenu = (): ContentMenuRow[] => {
        return data.map((section) => ({ title: section.titleId, subtitles: [] }));
    };

    return (
        <div>
            <ActionHeader
                title={t(titleId)}
                actions={actions}
                onBack={onBack}
                titleSuffixComponent={titleSuffixComponent}
            />
            <PaddedLayout>
                <div className="grid grid-cols-[192px_578px] gap-[6%]">
                    <ContentMenu rows={getContentMenu()} className="sticky top-24 h-fit p-0" />
                    <div className="flex flex-1 flex-col justify-center gap-4">
                        {data.map((section) => (
                            <div
                                key={getIdLink(section.titleId)}
                                id={getIdLink(section.titleId)}
                                className="scroll-mt-24"
                            >
                                <GridItemList titleId={section.titleId} data={section.rows} />
                            </div>
                        ))}
                        {createdAt ? (
                            <div className="mt-4">
                                <AuditInfo
                                    createdAt={createdAt}
                                    createdByEmployee={createdByEmployee}
                                    lastModifiedAt={lastModifiedAt}
                                    changedByEmployee={changedByEmployee}
                                />
                            </div>
                        ) : null}
                    </div>
                </div>
            </PaddedLayout>
        </div>
    );
}
